'use client';

import { BlurSwap } from '../../collection-showcase/scenes/playback-controls.jsx';
import { ShowcaseIcon } from '../../collection-showcase/scenes/scene-primitives.jsx';
import { CompletionMark } from '../../collection-showcase/scenes/playback-controls.jsx';

// Recovered from the IMAI v5 animation source; demo documents stay illustrative.
import * as React from 'react';
import {
  ShowcaseCopyContext,
  translateShowcaseNode,
} from '../../collection-showcase/translation';
import {
  Mn,
  quickTimeline,
  yn,
  researchSources,
  On,
  Sn,
  xn,
  I,
  F,
  hn,
  gn,
} from './research-facts';
export function QuickAnswer({ t: e, focus: t, onFocus: n }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let r = Mn(e),
    i = e < quickTimeline.stream;
  return (
    <div className={'flex flex-col gap-3'}>
      <div className={'flex justify-end'}>
        <p
          className={
            'enter text-ink max-w-[88%] rounded-[18px] bg-[var(--secondary)] px-4 py-2 text-[14px] leading-[22px] shadow-[var(--shadow-minimal)] sm:text-[15px] sm:leading-6'
          }
        >
          {translateShowcaseNode(showcaseCopy, yn)}
        </p>
      </div>
      <div
        className={
          'text-ink-3 flex h-7 items-center gap-2 px-1 text-[13.5px] transition-opacity duration-300'
        }
        style={{
          opacity: +(e >= quickTimeline.read),
        }}
      >
        <CompletionMark done={!i} className={'size-4'} />
        <span className={'num'}>
          {translateShowcaseNode(
            showcaseCopy,
            i ? 'Reading product pages' : 'Read'
          )}
          {translateShowcaseNode(showcaseCopy, ' ')}
          <span className={'text-ink'}>
            {translateShowcaseNode(showcaseCopy, r)}
          </span>
          {translateShowcaseNode(showcaseCopy, ' of ')}
          {translateShowcaseNode(showcaseCopy, researchSources.length)}
        </span>
        <span className={'ml-auto flex -space-x-1'}>
          {translateShowcaseNode(
            showcaseCopy,
            researchSources.slice(0, r).map((e) => (
              <span
                key={e.n}
                className={
                  'enter text-ink-3 grid size-5 place-items-center rounded-full bg-[var(--panel)] text-[9px] font-semibold uppercase shadow-[inset_0_0_0_1px_var(--border)]'
                }
                title={translateShowcaseNode(showcaseCopy, e.domain)}
              >
                {translateShowcaseNode(showcaseCopy, e.brand.charAt(0))}
              </span>
            ))
          )}
        </span>
      </div>
      <p
        className={
          'text-ink m-0 min-h-[120px] px-1 text-[15px] leading-[26px] text-pretty sm:text-[16px] sm:leading-[27px]'
        }
      >
        {translateShowcaseNode(
          showcaseCopy,
          On.map((r, i) => {
            if (r.at > e) return null;
            if (r.kind === 'word')
              return (
                <span key={i} className={'res-word'}>
                  {translateShowcaseNode(showcaseCopy, r.text)}
                </span>
              );
            let a = researchSources[r.n - 1],
              o = t === r.n;
            return (
              <React.Fragment key={i}>
                {translateShowcaseNode(showcaseCopy, ' ')}
                <button
                  type={'button'}
                  data-cite={r.n}
                  aria-label={translateShowcaseNode(
                    showcaseCopy,
                    `Source ${r.n}: ${a?.brand ?? ''}, ${a?.domain ?? ''}`
                  )}
                  aria-pressed={o}
                  onMouseEnter={() => n(r.n)}
                  onMouseLeave={() => n(null)}
                  onFocus={() => n(r.n)}
                  onBlur={() => n(null)}
                  onClick={() => n(o ? null : r.n)}
                  className={`res-cite num relative inline-grid h-[18px] min-w-[18px] place-items-center rounded-[5px] px-1 align-[2px] text-[10.5px] leading-none font-medium transition-[background-color,color] duration-150 ${o ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'text-ink-3 bg-[var(--tint-2)]'}`}
                >
                  {translateShowcaseNode(showcaseCopy, r.n)}
                </button>
              </React.Fragment>
            );
          })
        )}
        {translateShowcaseNode(
          showcaseCopy,
          e >= quickTimeline.stream && e < quickTimeline.streamEnd ? (
            <span className={'caret'} data-blink={'false'} aria-hidden={!0} />
          ) : null
        )}
      </p>
      <p
        className={'res-note text-ink-4 m-0 px-1 text-[12.5px] leading-5'}
        data-on={e >= quickTimeline.streamEnd}
      >
        {translateShowcaseNode(showcaseCopy, Sn)}
      </p>
      <div
        className={
          'res-note flex items-start gap-2.5 rounded-[10px] px-3 py-2.5 text-[13px] leading-5 shadow-[inset_0_0_0_1px_var(--border)]'
        }
        data-on={e >= quickTimeline.confirm}
      >
        <ShowcaseIcon
          name={'search'}
          className={'text-ink-3 mt-0.5 size-4 shrink-0'}
        />
        <span>
          <span className={'text-ink font-medium'}>
            {translateShowcaseNode(showcaseCopy, 'Couldn\u2019t confirm. ')}
          </span>
          <span className={'text-ink-3'}>
            {translateShowcaseNode(showcaseCopy, xn)}
          </span>
        </span>
      </div>
    </div>
  );
}
export const Pn = 50;
export const Fn = [50, 100, 150, 200, 250];
export const In = (e) => `${((e - Pn) / 210) * 100}%`;
export function PriceComparison({ shown: e, band: t, focus: n, onFocus: r }) {
  const showcaseCopy = React.use(ShowcaseCopyContext);
  let i = n === null ? null : researchSources[n - 1],
    a = i
      ? `${i.brand} · ${I(i.price)}${i.sale === null ? '' : ` · on sale ${I(i.sale)}`}`
      : `Target ${I(F.low)}–${F.high} · start at ${I(F.start)}`;
  return (
    <div className={'flex min-w-0 flex-col'}>
      <div className={'flex items-start justify-between gap-3 px-1 pb-3'}>
        <div className={'min-w-0'}>
          <p className={'label'}>
            {translateShowcaseNode(
              showcaseCopy,
              'Linen overshirts \xB7 checked '
            )}
            {translateShowcaseNode(showcaseCopy, hn)}
          </p>
          <p
            aria-live={'polite'}
            className={
              'text-ink mt-1.5 min-h-6 text-[15px] leading-6 font-medium tracking-[-0.01em] sm:text-[16px]'
            }
          >
            <BlurSwap value={a} className={'num'} />
          </p>
          <p className={'text-ink-4 h-5 truncate text-[12.5px] leading-5'}>
            <BlurSwap value={i ? i.product : 'Six product pages'} />
          </p>
        </div>
        <span
          className={
            'num text-ink-3 mt-0.5 flex shrink-0 items-center gap-1.5 text-[12px]'
          }
        >
          <ShowcaseIcon name={'clock'} className={'size-3.5'} />
          {translateShowcaseNode(showcaseCopy, gn)}
        </span>
      </div>
      <div
        className={
          'rounded-[12px] bg-[var(--canvas)] px-2 pt-3 pb-2 shadow-[inset_0_0_0_1px_var(--line)] sm:px-3'
        }
      >
        <div
          className={
            'relative grid grid-cols-[112px_1fr] sm:grid-cols-[144px_1fr]'
          }
          onMouseLeave={() => r(null)}
        >
          <div
            aria-hidden={!0}
            className={
              'pointer-events-none absolute top-0 right-2 bottom-6 left-[112px] sm:left-[144px]'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              Fn.map((e) => (
                <span
                  key={e}
                  className={'absolute inset-y-0 w-px bg-[var(--line)]'}
                  style={{
                    left: In(e),
                  }}
                />
              ))
            )}
            <span
              className={
                'res-band absolute inset-y-0 bg-[var(--tint-2)] shadow-[inset_1px_0_0_var(--line-strong),inset_-1px_0_0_var(--line-strong)]'
              }
              data-on={t}
              style={{
                left: In(F.low),
                width: `calc(${In(F.high)} - ${In(F.low)})`,
              }}
            />
            <span
              className={
                'res-start absolute inset-y-0 w-px bg-[var(--primary)]'
              }
              data-on={t}
              style={{
                left: In(F.start),
              }}
            />
          </div>
          {translateShowcaseNode(
            showcaseCopy,
            researchSources.map((t, i) => {
              let a = t.n === n,
                o = i < e;
              return (
                <button
                  key={t.brand}
                  type={'button'}
                  data-src={t.n}
                  aria-pressed={a}
                  onMouseEnter={() => r(t.n)}
                  onFocus={() => r(t.n)}
                  onClick={() => r(a ? null : t.n)}
                  aria-label={translateShowcaseNode(
                    showcaseCopy,
                    `${t.n}. ${t.brand}, ${t.product}, ${I(t.price)}${t.sale === null ? '' : `, on sale ${I(t.sale)}`}`
                  )}
                  className={`res-row relative col-span-2 grid h-10 grid-cols-subgrid items-center rounded-[8px] text-left transition-[background-color] duration-150 sm:h-11 ${a ? 'bg-[var(--tint)]' : ''}`}
                  data-drawn={o}
                >
                  <span
                    className={`flex min-w-0 items-center gap-2 pl-1.5 text-[13px] ${a ? 'text-ink font-medium' : 'text-ink-3'}`}
                  >
                    <span
                      className={`num grid size-[18px] shrink-0 place-items-center rounded-[5px] text-[10.5px] font-medium transition-[background-color,color] duration-200 ${a ? 'bg-[var(--primary)] text-[var(--primary-foreground)]' : 'text-ink-3 bg-[var(--tint-2)]'}`}
                    >
                      {translateShowcaseNode(showcaseCopy, t.n)}
                    </span>
                    <span className={'truncate'}>
                      {translateShowcaseNode(showcaseCopy, t.brand)}
                    </span>
                  </span>
                  <span className={'relative mr-2 h-full'}>
                    {translateShowcaseNode(
                      showcaseCopy,
                      t.sale === null ? null : (
                        <React.Fragment>
                          <span
                            className={
                              'res-sale-line bg-ink-4 absolute top-1/2 h-px -translate-y-1/2'
                            }
                            style={{
                              left: In(t.sale),
                              width: `calc(${In(t.price)} - ${In(t.sale)})`,
                            }}
                          />
                          <span
                            className={
                              'res-dot res-dot-sale absolute top-1/2 size-[11px] rounded-full bg-[var(--canvas)] shadow-[inset_0_0_0_1.5px_var(--ink-3)]'
                            }
                            style={{
                              left: In(t.sale),
                            }}
                          />
                        </React.Fragment>
                      )
                    )}
                    <span
                      className={
                        'res-dot absolute top-1/2 size-[11px] rounded-full bg-[var(--primary)]'
                      }
                      data-on={a}
                      style={{
                        left: In(t.price),
                      }}
                    />
                  </span>
                </button>
              );
            })
          )}
          <div
            aria-hidden={!0}
            className={
              'text-ink-4 relative col-start-2 mt-1.5 mr-2 h-5 text-[11px]'
            }
          >
            {translateShowcaseNode(
              showcaseCopy,
              Fn.map((e) => (
                <span
                  key={e}
                  className={'num absolute -translate-x-1/2'}
                  style={{
                    left: In(e),
                  }}
                >
                  {translateShowcaseNode(showcaseCopy, '$')}
                  {translateShowcaseNode(showcaseCopy, e)}
                </span>
              ))
            )}
          </div>
        </div>
      </div>
      <div
        className={
          'text-ink-3 flex flex-wrap items-center gap-x-4 gap-y-1.5 px-1 pt-3 text-[12px]'
        }
      >
        <span className={'flex items-center gap-1.5'}>
          <span className={'size-2.5 rounded-full bg-[var(--primary)]'} />
          {translateShowcaseNode(showcaseCopy, 'Full price')}
        </span>
        <span className={'flex items-center gap-1.5'}>
          <span
            className={
              'size-2.5 rounded-full shadow-[inset_0_0_0_1.5px_var(--ink-3)]'
            }
          />
          {translateShowcaseNode(showcaseCopy, 'On sale')}
        </span>
        <span className={'flex items-center gap-1.5'}>
          <span
            className={
              'h-3 w-4 rounded-[2px] bg-[var(--tint-2)] shadow-[inset_0_0_0_1px_var(--line-strong)]'
            }
          />
          {translateShowcaseNode(showcaseCopy, 'Recommended')}
        </span>
      </div>
    </div>
  );
}
export const Rn = 400;
export const zn = 340;
export const Bn = Rn + researchSources.length * zn + 200;
